// extracted by mini-css-extract-plugin
export default {"tabs":"BoardModeTabs_tabs__RFKH-","active":"BoardModeTabs_active__Bco1d"};